(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  class SmoothAnchor extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.anchor = this.querySelector('a');
      this.anchor.addEventListener('click', this.onClickRef.bind(this));
    }
    
    onClickRef(){
      event.preventDefault();
      const targetId = this.anchor.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if(targetElement){
        if(this.dataset.offset){
          let offset = 0;
          const offsetElement = document.querySelector(this.dataset.offset);
          if(!offsetElement){
            doScroll();
            if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
            return
          };
          const elementPosition = targetElement.getBoundingClientRect().top;
          offset = elementPosition + window.scrollY - offsetElement.offsetHeight;
          window.scrollTo({
            top: offset,
            behavior: "smooth"
          });
          if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
          return;
        }
        doScroll();
        if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
      }
        
      function doScroll(){
        targetElement.scrollIntoView({
          behavior: "smooth"
        });
      }
    }
  }
  if(!customElements.get('smooth-anchor')) customElements.define('smooth-anchor', SmoothAnchor);

  document.querySelectorAll('form[id^="ContactForm"]').forEach((contactForm) => {
    const requiredFields = contactForm.querySelectorAll('input[required]');

    const validateField = (field) => {
      const errorMessage = document.getElementById(field.getAttribute('aria-describedby'));
      let isValid = field.checkValidity();

      if (field.type === 'tel') {
        const digits = field.value.replace(/\D/g, '');
        isValid = digits.length >= 10;
      }

      field.classList.toggle('is-invalid', !isValid);
      field.classList.toggle('is-valid', isValid && field.value.trim() !== '');
      field.setAttribute('aria-invalid', String(!isValid));

      if (errorMessage) errorMessage.classList.toggle('is-visible', !isValid);
      return isValid;
    };

    requiredFields.forEach((field) => {
      field.addEventListener('blur', () => validateField(field));
      field.addEventListener('input', () => {
        if (field.classList.contains('is-invalid')) validateField(field);
      });
    });

    contactForm.addEventListener('submit', (event) => {
      let formIsValid = true;
      let firstInvalidField = null;

      requiredFields.forEach((field) => {
        const fieldIsValid = validateField(field);
        if (!fieldIsValid && !firstInvalidField) firstInvalidField = field;
        formIsValid = fieldIsValid && formIsValid;
      });

      if (!formIsValid) {
        event.preventDefault();
        firstInvalidField?.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
